import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "description",
  "use": "description-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"description\"><path d=\"M8.25 11.25v-4.5h-1.5v4.5h1.5zM0 7.5C0 11.644 3.356 15 7.5 15S15 11.644 15 7.5 11.644 0 7.5 0A7.498 7.498 0 000 7.5zm1.5 0c0-3.308 2.692-6 6-6 3.307 0 6 2.692 6 6 0 3.307-2.693 6-6 6-3.308 0-6-2.693-6-6zm6.75-2.25v-1.5h-1.5v1.5h1.5z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol